<template>
  <section class="card-wrapper">
    <div class="card-wrapper__title-container">
      <h3 class="card-wrapper__title">{{ title }}</h3>
      <slot name="title" />
    </div>

    <slot />
  </section>
</template>

<script>
  export default {
    name: 'card-wrapper',

    props: {
      title: { type: String, default: '' }
    }
  }
</script>

<style lang="scss" scoped>
@import '~scss/variables';

.card-wrapper {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 20px;
  padding: 15px;

  &__title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    font-size: 24px;
    font-weight: 400;
    color: $col-text;
    line-height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/common/UI/CardWrapper.vue